import React, { useRef, useCallback } from "react"
import { Container, Graphics } from "@inlet/react-pixi"

const Rect = ({ x, y, width, height, color }) => {
  const ref = useRef()
  const draw = useCallback(
    g => {
      g.clear()
      g.beginFill(color || 0)
      g.lineStyle(0)
      g.drawRect(0, 0, width, height)
      g.endFill()
    },
    [width, height, color]
  )

  return (
    <Container x={x} y={y}>
      <Graphics ref={ref} draw={draw} />
    </Container>
  )
}
export default Rect
